import { createFileRoute } from "@tanstack/react-router";

import BrsConnectionPage from "@/features/dashboard/pages/brs-connection";

export const Route = createFileRoute("/(app)/ops/connections/brs")({
  component: () => <BrsConnectionPage />,
});
